import React from "react";
import { Heading } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { useForm, FormProvider } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";

import {
  CreateUserFormValues,
  createUserFormSchema,
} from "modules/user/informations/schemas/formSchemas";
import UserActionBar from "modules/user/informations/components/UserActionBar";
import UserForms from "modules/user/shared/components/UserForms";
import ScreenContainer from "modules/shared/components/ScreenContainer/ScreenContainer";

const CreateUser = () => {
  const { t } = useTranslation();

  const methods = useForm<CreateUserFormValues>({
    defaultValues: { status: "ON" },
    resolver: zodResolver(createUserFormSchema),
  });

  return (
    <FormProvider {...methods}>
      <UserActionBar />
      <ScreenContainer>
        <Heading as="h1" size="lg" mb={10} mt={10}>
          {t("create_user.title")}
        </Heading>
        <UserForms />
      </ScreenContainer>
    </FormProvider>
  );
};

export default CreateUser;
